import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { AccountService } from '../../service/data/account.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { NavigationService } from '../../../core/service/navigation.service';

@Component({
    selector: 'app-support-form',
    templateUrl: './support-form.component.html',
    styleUrls: ['./support-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SupportFormComponent {
  constructor(
    private _dataService: AccountService,
    private _modalService: ActionWindowService,
    private _navigation: NavigationService,
    fb: FormBuilder,
    fcf: FormControlExFactory
  ) {
    this.form = fb.group({
      message: fcf.create('SUPPORT.MESSAGE', ''),
    });
  }

  form: FormGroup;

  cancel() {
    this._modalService.close();
  }

  sendMail() {
    if (this.form.invalid) return;

    this.form.value.page = this._navigation.url;
    const formValue = this.form.value;
    this._dataService.support(formValue).subscribe(res => {
      this._modalService.close();
    });
  }
}
